import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import getQuantities from 'selectors/exchange/getQuantities';

import Modal from 'components/Modal';

import BazaarDialogComponent from './BazaarDialogComponent';

class BazaarDialogContainer extends Component {
  static displayName = 'BazaarDialogContainer';

  mounted = false;

  state = {
    successMessage: null,
  };

  componentDidMount = () => {
    // We've mounted.
    this.mounted = true;
  };

  componentDidUpdate = (prevProps) => {
    const { activeItem } = this.props;
    // If by some chance we've changed active items without an unmount in between,
    // then ensure that we clobber the success message.
    if (prevProps.activeItem !== activeItem) {
      this.setState({ successMessage: null });
    }
  };

  componentWillUnmount = () => {
    // We're unmounted.
    this.mounted = false;
  };

  handleRequestClose = () => {
    const { onRequestClose } = this.props;
    onRequestClose();
    // Set a brief timeout so that we don't clear before the modal disappears
    // setTimeout(() => this.setState({ successMessage: null }), 200);
  };

  handleTransactionComplete = ({ successMessage }) => {
    // If we're mounted, then show the success message. If the user has closed the dialog,
    // unmounting us, the transaction will still go through, but we won't update the state to
    // show the success message on the next mount.
    if (this.mounted) {
      this.setState({ successMessage });
    }
  };

  /**
   * Render
   * @return {Object}
   */
  render() {
    const { isFetchingSellItem, isOpen, quantities } = this.props;
    const { successMessage } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.handleRequestClose}
      >
        <BazaarDialogComponent
          isTransacting={isFetchingSellItem}
          quantities={quantities}
          successMessage={successMessage}
          onRequestClose={this.handleRequestClose}
          onTransactionComplete={this.handleTransactionComplete}
        />
      </Modal>
    );
  }
}

BazaarDialogContainer.propTypes = {
  activeItem: PropTypes.shape({}).isRequired,
  isFetchingSellItem: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  quantities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => {
  const {
    exchange: {
      activeItem, isDialogOpen, isFetchingSellItem, successMessage,
    },
  } = state;
  const quantities = getQuantities(state);
  return {
    activeItem,
    isFetchingSellItem,
    quantities,
    successMessage,
    isOpen: isDialogOpen,
  };
};

export default withRouter(connect(mapStateToProps)(BazaarDialogContainer));
